var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 16,
  height: 16,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.345 31.458a1.67 1.67 0 0 1-1.17-.478L.485 2.777A1.607 1.607 0 0 1 .527.517a1.676 1.676 0 0 1 2.299-.04l28.69 28.204c.472.465.614 1.164.358 1.772a1.66 1.66 0 0 1-1.528 1.005"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.655 31.458a1.66 1.66 0 0 1-1.528-1.005 1.61 1.61 0 0 1 .359-1.772L29.176.477a1.676 1.676 0 0 1 2.298.04c.63.62.648 1.619.04 2.26L2.824 30.98a1.67 1.67 0 0 1-1.169.478"
})));
export default SvgIcoClose;